import { useState } from "react";
import { api } from "@/App";
import { Check, Loader2, Mail, Plus, Sparkles } from "lucide-react";
import { LaunchCardTimer } from "@/components/LaunchPromo";
import { MINT } from "@/components/RecastSection";
import { goToCheckout } from "@/components/CheckoutPage";

const errText = (e) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Something went wrong, please try again.");

function startCheckout(body, setBusy, setErr) {
  setBusy(body.lookup_key); setErr(null);
  goToCheckout(body);
}




function DenoiseCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border border-[#00e5ff] p-5 flex flex-col gap-3" data-testid="denoise-price-card">
      <div className="flex items-center gap-2"><span className="font-display uppercase text-xl">KolorKlinic <span className="text-[#00e5ff]">Denoise</span></span><span className="chip text-[#00e5ff] border-[#00e5ff] ml-auto">launch offer</span></div>
      <div><span className="font-display text-4xl">€79</span> <span className="text-[#5c6479] line-through">€129</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
      <ul className="text-sm text-[#9ba3b4] space-y-1">
        <li className="flex gap-2"><Check size={14} className="text-[#00e5ff] mt-1" />Lifetime licence, runs fully offline</li>
        <li className="flex gap-2"><Check size={14} className="text-[#00e5ff] mt-1" />Up to 3 of your machines</li>
        <li className="flex gap-2"><Check size={14} className="text-[#00e5ff] mt-1" />Free trial: download and use it now, with a watermark</li>
      </ul>
      <LaunchCardTimer />
      <div className="flex gap-2 mt-auto">
        <button onClick={onBuy} disabled={!!busy} className="flex-1 px-4 py-2 text-sm font-semibold bg-[#00e5ff] text-black hover:bg-[#5ff0ff] transition-colors flex items-center justify-center gap-2" data-testid="denoise-buy-btn">
          {busy === "denoise_launch" && <Loader2 className="spin" size={14} />} Buy Denoise
        </button>
        <a href="/activate" className="btn-ghost px-4 py-2 text-sm" data-testid="denoise-activate-link">Activate</a>
      </div>
    </div>
  );
}

const ROSE = "#ff7a9c";

function SkinCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border p-5 flex flex-col gap-3" style={{ borderColor: ROSE }} data-testid="skin-price-card">
      <div className="flex items-center gap-2"><span className="font-display uppercase text-xl">KolorKlinic <span style={{ color: ROSE }}>Skin</span></span><span className="chip ml-auto" style={{ color: ROSE, borderColor: ROSE }}>new</span></div>
      <div><span className="font-display text-4xl" data-testid="skin-price">€79</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
      <ul className="text-sm text-[#9ba3b4] space-y-1">
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: ROSE }} />Lifetime licence, runs fully offline</li>
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: ROSE }} />Up to 3 of your machines</li>
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: ROSE }} />Free trial: download and use it now, with a watermark</li>
      </ul>
      <LaunchCardTimer testid="skin-launch-card-timer" />
      <div className="flex gap-2 mt-auto">
        <button onClick={onBuy} disabled={!!busy} className="flex-1 px-4 py-2 text-sm font-semibold text-black transition-opacity hover:opacity-85 flex items-center justify-center gap-2" style={{ background: ROSE }} data-testid="skin-buy-btn">
          {busy === "skin_launch" && <Loader2 className="spin" size={14} />} Buy Skin
        </button>
        <a href="/activate" className="btn-ghost px-4 py-2 text-sm" data-testid="skin-activate-link">Activate</a>
      </div>
    </div>
  );
}

const EMBER = "#ff6a3d";

function TextureCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border p-5 flex flex-col gap-3" style={{ borderColor: EMBER }} data-testid="texture-price-card">
      <div className="flex items-center gap-2"><span className="font-display uppercase text-xl">KolorKlinic <span style={{ color: EMBER }}>Texture</span></span><span className="chip ml-auto" style={{ color: EMBER, borderColor: EMBER }}>new</span></div>
      <div><span className="font-display text-4xl" data-testid="texture-price">€99</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
      <ul className="text-sm text-[#9ba3b4] space-y-1">
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: EMBER }} />Spatial equalizer, halation, diffusion and film grain</li>
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: EMBER }} />Lifetime licence, runs fully offline on up to 3 machines</li>
        <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: EMBER }} />Free trial: download and use it now, with a watermark</li>
      </ul>
      <div className="flex gap-2 mt-auto">
        <button onClick={onBuy} disabled={!!busy} className="flex-1 px-4 py-2 text-sm font-semibold text-black transition-opacity hover:opacity-85 flex items-center justify-center gap-2" style={{ background: EMBER }} data-testid="texture-buy-btn">
          {busy === "texture_launch" && <Loader2 className="spin" size={14} />} Buy Texture
        </button>
        <a href="/activate" className="btn-ghost px-4 py-2 text-sm" data-testid="texture-activate-link">Activate</a>
      </div>
    </div>
  );
}



const VIOLET = "#c48bff";
function ReactorCard({ busy, buy }) {
  const [key, setKey] = useState("");
  const li = (t) => <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: VIOLET }} />{t}</li>;
  return (
    <div id="reactor-pricing" className="scroll-mt-6 bg-[#0e1013] border p-5 flex flex-col gap-3" style={{ borderColor: VIOLET }} data-testid="reactor-price-card">
      <div className="flex items-center gap-2"><span className="font-display uppercase text-xl">KolorKlinic <span style={{ color: VIOLET }}>Reactor</span></span><span className="chip ml-auto" style={{ color: VIOLET, borderColor: VIOLET }}>new</span></div>
      <div><span className="font-display text-4xl" data-testid="reactor-price">€129</span><span className="text-[#9ba3b4] text-sm"> one-time · €79 for Texture owners</span></div>
      <ul className="text-sm text-[#9ba3b4] space-y-1">
        {li("Film colour: tone curve, per-hue colour, casts, bleach bypass, 10 film looks")}
        {li("Plus the full Texture engine: grain, halation, diffusion, gate weave")}
        {li("Lifetime licence, runs fully offline on up to 3 machines")}
      </ul>
      <div className="flex gap-2">
        <button onClick={() => buy({ lookup_key: "reactor_launch" })} disabled={!!busy} className="flex-1 px-4 py-2 text-sm font-semibold text-black hover:opacity-85 flex items-center justify-center gap-2" style={{ background: VIOLET }} data-testid="reactor-buy-btn">
          {busy === "reactor_launch" && <Loader2 className="spin" size={14} />} Buy Reactor
        </button>
        <a href="/activate" className="btn-ghost px-4 py-2 text-sm" data-testid="reactor-activate-link">Activate</a>
      </div>
      <div className="flex gap-2">
        <input value={key} onChange={(e) => setKey(e.target.value)} placeholder="Your Texture key (KKT-...)" className="flex-1 bg-black border border-[#2a2f3a] px-3 py-2 text-sm font-mono" data-testid="reactor-upgrade-key-input" />
        <button onClick={() => buy({ lookup_key: "reactor_upgrade", licence_key: key.trim() })} disabled={!!busy || !key.trim()} className="px-4 py-2 text-sm border hover:bg-[#c48bff] hover:text-black transition-colors" style={{ borderColor: VIOLET, color: VIOLET }} data-testid="reactor-upgrade-btn">
          {busy === "reactor_upgrade" && <Loader2 className="spin" size={14} />} Upgrade €79
        </button>
      </div>
      <a href="#reactor" className="font-mono text-xs uppercase tracking-widest" style={{ color: VIOLET }} data-testid="reactor-trial-link">Free trial download →</a>
    </div>
  );
}

function GenAlphaCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border border-[#e69d27]/70 p-5 md:p-6 grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-5" data-testid="genalpha-price-card">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display uppercase text-xl">KolorKlinic <span className="text-[#e69d27]">Gen Alpha</span></span>
          <span className="chip text-[#e69d27] border-[#e69d27]">bring your own fal.ai key</span>
        </div>
        <ul className="text-sm text-[#9ba3b4] space-y-1">
          <li className="flex gap-2"><Check size={14} className="text-[#e69d27] mt-1" />AI character matte for whole clips (SAM 3.1 + BiRefNet edges)</li>
          <li className="flex gap-2"><Check size={14} className="text-[#e69d27] mt-1" />No subscription: fal.ai bills your own account for each matte</li>
          <li className="flex gap-2"><Check size={14} className="text-[#e69d27] mt-1" />Lifetime licence, key emailed instantly</li>
        </ul>
      </div>
      <div className="flex flex-col justify-between gap-4">
        <div><span className="font-display text-5xl" data-testid="genalpha-price">€99</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
        <button onClick={onBuy} disabled={!!busy} className="btn-amber px-4 py-3 text-sm flex items-center justify-center gap-2" data-testid="genalpha-buy-btn">
          {busy === "genalpha_lifetime" && <Loader2 className="spin" size={14} />} Buy Gen Alpha
        </button>
      </div>
    </div>
  );
}

function RecastCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border p-5 md:p-6 grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-5" style={{ borderColor: MINT }} data-testid="recast-price-card">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display uppercase text-xl">KolorKlinic <span style={{ color: MINT }}>Recast</span></span>
          <span className="chip" style={{ color: MINT, borderColor: MINT }}>new · bring your own fal.ai key</span>
        </div>
        <ul className="text-sm text-[#9ba3b4] space-y-1">
          <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: MINT }} />Smile, blinks, brows, gaze and head pose after the shoot, or retarget from a driver clip</li>
          <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: MINT }} />Free blink removal, plus skin detail restore and temporal stabilising</li>
          <li className="flex gap-2"><Check size={14} className="mt-1" style={{ color: MINT }} />No subscription: fal.ai bills your own account. Lifetime licence, key emailed instantly</li>
        </ul>
      </div>
      <div className="flex flex-col justify-between gap-4">
        <div><span className="font-display text-5xl" data-testid="recast-price">€99</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
        <button onClick={onBuy} disabled={!!busy} className="px-4 py-3 text-sm font-semibold uppercase text-black flex items-center justify-center gap-2 hover:opacity-85 transition-opacity" style={{ background: MINT }} data-testid="recast-card-buy-btn">
          {busy === "recast_lifetime" && <Loader2 className="spin" size={14} />} Buy Recast
        </button>
      </div>
    </div>
  );
}

function AiPackCard({ busy, onBuy }) {
  return (
    <div className="bg-[#0e1013] border border-white p-5 md:p-6 grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-5" data-testid="aipack-price-card">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display uppercase text-xl">KolorKlinic <span className="text-white">AI Pack</span></span>
          <span className="chip" style={{ background: "#fff", color: "#000", borderColor: "#fff" }} data-testid="aipack-save-chip">save €29</span>
        </div>
        <div className="flex flex-wrap gap-2"><span className="chip text-[#e69d27] border-[#e69d27]">Gen Alpha</span><span className="chip" style={{ color: MINT, borderColor: MINT }}>Recast</span></div>
        <ul className="text-sm text-[#9ba3b4] space-y-1">
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />AI matte and performance fixes, two lifetime licences</li>
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />Both run on your own fal.ai key, no subscription</li>
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />Both keys emailed instantly</li>
        </ul>
      </div>
      <div className="flex flex-col justify-between gap-4">
        <div><span className="font-display text-5xl" data-testid="aipack-price">€169</span> <span className="text-[#5c6479] line-through" data-testid="aipack-full-price">€198</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
        <button onClick={onBuy} disabled={!!busy} className="px-4 py-3 text-sm font-semibold uppercase bg-white text-black hover:bg-[#e6e8ee] transition-colors flex items-center justify-center gap-2" data-testid="aipack-buy-btn">
          {busy === "ai_pack" && <Loader2 className="spin" size={14} />} Buy the AI Pack
        </button>
      </div>
    </div>
  );
}

const SUITE = [["Denoise", "#00e5ff"], ["Skin", ROSE], ["Texture", EMBER]];

function BundleCard({ busy, onBuy }) {
  return (
    <div className="relative bg-[#0e1013] border border-white p-5 md:p-6 grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-5" data-testid="bundle-price-card">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display uppercase text-xl">KolorKlinic <span className="text-white">Finishing Suite</span></span>
          <span className="chip" style={{ background: "#fff", color: "#000", borderColor: "#fff" }} data-testid="bundle-save-chip">save €58</span>
        </div>
        <div className="flex flex-wrap gap-2">{SUITE.map(([n, c]) => <span key={n} className="chip" style={{ color: c, borderColor: c }}>{n}</span>)}</div>
        <ul className="text-sm text-[#9ba3b4] space-y-1">
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />All three plugins, three lifetime licences, each on up to 3 machines</li>
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />ACES and DaVinci Wide Gamut ready, fully offline</li>
          <li className="flex gap-2"><Check size={14} className="text-white mt-1" />All three keys emailed instantly</li>
        </ul>
      </div>
      <div className="flex flex-col justify-between gap-4">
        <div><span className="font-display text-5xl" data-testid="bundle-price">€199</span> <span className="text-[#5c6479] line-through" data-testid="bundle-full-price">€257</span><span className="text-[#9ba3b4] text-sm"> one-time</span></div>
        <button onClick={onBuy} disabled={!!busy} className="px-4 py-3 text-sm font-semibold uppercase bg-white text-black hover:bg-[#e6e8ee] transition-colors flex items-center justify-center gap-2" data-testid="bundle-buy-btn">
          {busy === "suite_bundle" && <Loader2 className="spin" size={14} />} Buy the suite
        </button>
      </div>
    </div>
  );
}

export const AiPricing = () => {
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState(null);
  const buy = (body) => startCheckout(body, setBusy, setErr);
  return (
    <section id="pricing" className="scroll-mt-6 card p-6 space-y-5" data-testid="ai-pricing-section">
      <div>
        <h2 className="font-display uppercase text-3xl md:text-4xl leading-none">AI pricing</h2>
        <p className="mt-2 text-sm text-[#9ba3b4] max-w-2xl">One-time licences. Processing runs on your own fal.ai account, so there's no subscription.</p>
      </div>
      {err && <div className="border border-[#ff453a] text-[#ff453a] px-3 py-2 text-sm" data-testid="ai-pricing-error">{err}</div>}
      <AiPackCard busy={busy} onBuy={() => buy({ lookup_key: "ai_pack" })} />
      <GenAlphaCard busy={busy} onBuy={() => buy({ lookup_key: "genalpha_lifetime" })} />
      <RecastCard busy={busy} onBuy={() => buy({ lookup_key: "recast_lifetime" })} />
      <p className="text-xs text-[#5c6479]">Prices in EUR, taxes handled at checkout. fal.ai usage is billed separately by fal.ai. Secure checkout by Stripe.</p>
    </section>
  );
};

export const PricingSection = () => {
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState(null);
  const buy = (body) => startCheckout(body, setBusy, setErr);
  return (
    <section id="pricing" className="card p-6 space-y-5" data-testid="pricing-section">
      <div>
        <h2 className="font-display uppercase text-3xl md:text-4xl leading-none">Pricing</h2>
        <p className="mt-2 text-sm text-[#9ba3b4] max-w-2xl">Denoise, Skin, Texture and Reactor run on your own machine, so you buy them once and own them.</p>
      </div>
      {err && <div className="border border-[#ff453a] text-[#ff453a] px-3 py-2 text-sm" data-testid="pricing-error">{err}</div>}
      <BundleCard busy={busy} onBuy={() => buy({ lookup_key: "suite_bundle" })} />
      <DenoiseCard busy={busy} onBuy={() => buy({ lookup_key: "denoise_launch" })} />
      <SkinCard busy={busy} onBuy={() => buy({ lookup_key: "skin_launch" })} />
      <TextureCard busy={busy} onBuy={() => buy({ lookup_key: "texture_launch" })} />
      <ReactorCard busy={busy} buy={buy} />
      <a href="/ai#pricing" className="flex items-center justify-between gap-4 border border-[#2a2f3d] bg-[#0e1013] p-4 text-sm transition-colors hover:border-[#4ff2c2]" data-testid="pricing-ai-link">
        <span className="text-[#c9ced8]"><b className="text-white">Looking for the AI tools?</b> Gen Alpha, Recast and the AI Pack are on the KolorKlinic AI page.</span>
        <span className="font-semibold whitespace-nowrap" style={{ color: MINT }}>KolorKlinic AI pricing →</span>
      </a>
      <p className="text-xs text-[#5c6479]">Prices in EUR, taxes handled at checkout. Card, MB WAY and other local methods where available. Secure checkout by Stripe.</p>
    </section>
  );
};
